module.exports = __webpack_public_path__ + "static/media/top_one.a485ffbc.svg";